import { render, staticRenderFns } from "./ShopifyProductLog.vue?vue&type=template&id=94da41c6"
import script from "./ShopifyProductLog.vue?vue&type=script&lang=js"
export * from "./ShopifyProductLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports